module.exports = __webpack_public_path__ + "img/14_27.67ef4354.png";